import { CompanyPage } from '@pages/company';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Профиль компании', 'Информация о компании');
}

export default CompanyPage;
